// Vuex 全局状态管理
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    asideIsCollapse: false, // 侧边栏折叠状态
    drawerIsShow: false, // 抽屉显示状态
    routerMessages: [], // 面包屑路由信息
    userInfo: {
      userName: '',
      id: undefined
    }
  },
  getters: {
  },
  mutations: {
    // 切换侧边栏折叠状态，可传入指定值或自动取反
    asideChange (state, data) {
      if (data !== undefined) {
        state.asideIsCollapse = data
      } else {
        state.asideIsCollapse = !state.asideIsCollapse
      }
    },
    // 切换抽屉显示状态
    drawerChange (state) {
      state.drawerIsShow = !state.drawerIsShow
    },
    // 更新面包屑路由信息
    routerMessagesChange (state, data) {
      state.routerMessages = data
    },
    // 更新当前登录用户信息
    userInfoChange (state, data) {
      state.userInfo.userName = data.realName
      state.userInfo.id = data.id
    }
  },
  actions: {
  },
  modules: {
  }
})
